import React from "react";
import ArrowUpwardRoundedIcon from "@material-ui/icons/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@material-ui/icons/ArrowDownwardRounded";
import RemoveRoundedIcon from "@material-ui/icons/RemoveRounded";

const LabelResumeKomparasi = ({
	sekolah1,
	sekolah2,
	mapel,
	skor1,
	skor2,
	rata,
}) => {
	let elDesc;
	if (rata) {
		elDesc = <div className="label-resume-comp">Secara rata-rata, performa literasi tertinggi adalah {<b>{sekolah1}</b>} (<b>{skor1}</b>) dan terendah adalah {sekolah2} (<b>{skor2}</b>)</div>
	} else {
		elDesc = <div className="label-resume-comp">Performa literasi {mapel} terbaik diperoleh dari {<b>{sekolah1}</b>} (<b>{skor1}</b>), sementara terendah diperoleh dari {<b>{sekolah2}</b>} (<b>{skor2}</b>)</div>
	}

	return (
		<div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
			<div style={{paddingTop: '7px'}}><img src="/assets/image/verified-green.svg" width={30} alt="" /></div>
			<div className="desc-chart" style={{textAlign: 'justify'}}>
				{elDesc}
			</div>
		</div>
	);
};

export default LabelResumeKomparasi;
